import React from "react";
import { useRouteError } from "react-router-dom";

const NotFound = () => {
//   const error = useRouteError();

  return (
    <div>
      <p>
        Page inexistante
      </p>
    </div>
  );
};

export default NotFound;
